const skJSON = {};

export default skJSON;
